export default class Item {

    constructor(dependencia=null, tipo='', valor=0, descricao='', heranca=null) {
        this.dependencia = dependencia;
        this.tipo = tipo;
        this.valor = valor;
        this.descricao = descricao;
        this.heranca = heranca;
    }
}



// WEBPACK FOOTER //
// ./src/domain/declaracao/item.js